import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'help_center-header_switcher-click';

/**
 * Click event on hub switcher located in the header of help center, and customer can select "for Retailer" or "for Brand" options
 */
export function trackHelpCenterHeaderSwitcherClick(
  retailerToken: string,
  brandToken: string,
  View: string,
  SwitchOption2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { retailerToken, brandToken, View, SwitchOption2 },
  });
}
